var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveCross = function SvgRemoveCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.044 8.022-3.066-3.066L13 9.934 8.022 4.956 4.956 8.022 9.934 13l-4.978 4.978 3.066 3.066L13 16.066l4.978 4.978 3.066-3.066L16.066 13z"
  })));
};
export { SvgRemoveCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiI+PHBhdGggZD0iTTIxLjA0NCA4LjAyMmwtMy4wNjYtMy4wNjZMMTMgOS45MzQgOC4wMjIgNC45NTYgNC45NTYgOC4wMjIgOS45MzQgMTNsLTQuOTc4IDQuOTc4IDMuMDY2IDMuMDY2TDEzIDE2LjA2Nmw0Ljk3OCA0Ljk3OCAzLjA2Ni0zLjA2NkwxNi4wNjYgMTN6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4K";